import React from "react";
import { makeStyles } from "@material-ui/core";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  toggleRoot: {
    display: "flex",
    alignItems: "center",
    width: 220,
    height: 35,
    borderRadius: 999,
    backgroundColor: "#f0b7d6",
    position: "relative",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    overflow: "hidden",
    marginLeft: "auto",
    padding: 4,
    boxSizing: "border-box",
  },
  toggleSlider: {
    position: "absolute",
    width: "calc(50% - 8px)",
    height: "calc(100% - 8px)",
    top: 4,
    backgroundColor: "#ec407a",
    borderRadius: 9999,
    transition: "left 0.2s ease",
    zIndex: 1,
  },
  toggleText: {
    flex: 1,
    textAlign: "center",
    zIndex: 2,
  },
}));

function TwoSectionToggle({ value, onChange, leftLabel, rightLabel }) {
  const classes = useStyles();

  return (
    <Box className={classes.toggleRoot}>
      <Box
        className={classes.toggleSlider}
        style={{ left: value ? "calc(50% + 4px)" : "4px" }}
      />
      <Box
        className={classes.toggleText}
        onClick={() => onChange(false)}
        style={{ color: value ? "#000" : "#fff" }}
      >
        {leftLabel}
      </Box>
      <Box
        className={classes.toggleText}
        onClick={() => onChange(true)}
        style={{ color: !value ? "#000" : "#fff" }}
      >
        {rightLabel}
      </Box>
    </Box>
  );
}

export default TwoSectionToggle;
